// CustomerLabsTag.jsx
import { useEffect } from "react";

/**
 * CustomerLabs tracking loader for React
 * @param {object} props
 * @param {string} [props.siteToken="cl79026oknmil0"] - The token in the script URL.
 * @param {string} [props.scriptSrc] - If you prefer, pass the full script URL instead.
 * @param {boolean} [props.enabled=true] - Toggle loading on/off.
 */
export default function CustomerLabsTag({ siteToken = "cl79026oknmil0", scriptSrc, enabled = true }) {
  useEffect(() => {
    if (!enabled || typeof window === "undefined") return;

    // prevent duplicate loads
    if (window._cl && window._cl.__loaded) return;

    (function (t, e, r, c, a, n, s) {
      t.ClAnalyticsObject = a;
      t[a] = t[a] || [];
      t[a].methods = ["trackSubmit", "trackClick", "pageview", "identify", "track", "trackConsent"];
      t[a].factory = function (m) {
        return function () {
          var args = Array.prototype.slice.call(arguments);
          args.unshift(m);
          t[a].push(args);
        };
      };
      for (var i = 0; i < t[a].methods.length; i++) {
        var o = t[a].methods[i];
        t[a][o] = t[a].factory(o);
      }
      n = e.createElement(r);
      s = e.getElementsByTagName(r)[0];
      n.async = 1;
      n.crossOrigin = "anonymous";
      n.src = c;
      s.parentNode.insertBefore(n, s);
    })(
      window,
      document,
      "script",
      scriptSrc || `https://cdn.js.customerlabs.co/${siteToken}.js`,
      "_cl"
    );

    // version flag from the snippet
    window._cl.SNIPPET_VERSION = "2.0.0";
    window._cl.__loaded = true;
  }, [siteToken, scriptSrc, enabled]);

  return null; // no UI
}
